export default __webpack_public_path__ + "static/media/PDFReport-Interior-Pg4.0c8d8938.png";